// this file is automatically generated by git.version.ts script
export const versions = {commit: '8b592cf11', tag: '2026.6.004-RELEASE'};
